import { FC } from 'react'
import { Alert, ButtonGroup, Col, Row } from 'react-bootstrap'
import { CallToActionsProps, CtaType } from '../Forms.d'
import { useAppSelector } from '../../../../store/hooks'
import { Language } from '../../../../features/security/security.slice'
import HeaderCtaDialog from '../../dialogs/HeaderCtaDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons'

const CallToActions: FC<CallToActionsProps> = ({
    formikProps,
    translations,
    availablePages,
    deletedCtas,
    setDeletedCtas,
    activeLocale,
}) => {
    const theme = useAppSelector((state) => state.theme.theme)
    const initData = useAppSelector((state: any) => state.security.initData)

    const { values } = formikProps

    const ctas = Object.values(values.ctas)

    return (
        <Row>
            {ctas.length > 3 ? (
                <Alert variant="warning" className="border-0">
                    <strong>Warning!</strong> More than 3 actions in the header
                    could potentially harm the UI/UX!
                </Alert>
            ) : null}
            <Col className="text-center p-3" xl={12}>
                <ButtonGroup size="lg" className="shadow">
                    {ctas.map((cta: CtaType) => {
                        const localeKey = activeLocale || initData.languages.default.locale
                        const lang: Language =
                            initData.languages.data[localeKey]

                        const ctaLabelProp = `header_cta_${cta.id}_label_${lang.id}`

                        return (
                            <HeaderCtaDialog
                                key={cta.id}
                                cta={cta}
                                isNew={false}
                                formikProps={formikProps}
                                translations={translations}
                                availablePages={availablePages}
                                deletedCtas={deletedCtas}
                                setDeletedCtas={setDeletedCtas}
                                button={{
                                    label: values.ctas[cta.id][ctaLabelProp],
                                    variant:
                                        cta.style === 'light'
                                            ? theme === 'dark'
                                                ? 'dark'
                                                : 'light'
                                            : 'primary',
                                }}
                            />
                        )
                    })}
                    <HeaderCtaDialog
                        cta={{
                            label: '',
                            active: false,
                            url_type: 'external',
                            url: '',
                            url_id: null,
                            style: 'light',
                            order: null,
                        }}
                        isNew
                        formikProps={formikProps}
                        translations={translations}
                        availablePages={availablePages}
                        deletedCtas={deletedCtas}
                        setDeletedCtas={setDeletedCtas}
                        button={{
                            label: (
                                <>
                                    <FontAwesomeIcon icon={faPlusSquare} />
                                    {ctas.length <= 0 && (
                                        <span className="ms-2">
                                            Create new action
                                        </span>
                                    )}
                                </>
                            ),
                            variant: 'secondary',
                        }}
                    />
                </ButtonGroup>
            </Col>
        </Row>
    )
}

export default CallToActions
